import { AloBaseLg, getDefaultAloBaseLg } from "./AloBaseLg"


export interface AloBioLg extends AloBaseLg  {        
}

export const getDefaultAloBioLg = ():AloBioLg => {
    return {
        ...getDefaultAloBaseLg("en")
    }
}